var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.30002 16.9333L9.73335 15.5333L4.13335 9.93333H21.6667V7.93333H4.13335L9.76669 2.3L8.33335 0.900002L0.30002 8.93333L8.30002 16.9333Z","fill":"black"}));
}

ArrowRight.defaultProps = {"width":"22","height":"17","viewBox":"0 0 22 17","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
